/**
 * This Middleware is used to filter calls for CEAP engagements.
 * Given Any user, If engagement Status is 33/CEAP then redirect download document to API
 * Action is filtered only if the current engagement status is 33
 * DOCHELPER_DOWNLOAD_DOCUMENT and converted to api actions with responsetype as blob,
 * -- so that the document download is not routed to dochelper
 */

import env from '../util/env';

const ceapDownloadMiddleware = (config) => (store) => (next) => (action) => {
	if (!action.isOnline) {
		return next(action);
    }

    const engagementStatusId = store.getState().engagement.engagementStatusId;

    // return to next middleware if enagagement status is not 33
        if(engagementStatusId !== 33){
            return next(action);
        }

    if(action.type === 'KRONOS_DOCHELPER_DOWNLOAD_DOCUMENT'){
        const data = action.meta.docHelper.payload;
        let docUrl = `${env.getDocServiceUrl()}/restoretolocal/documents.json/${data.documentId}?engagementid=${data.engagementId}&fileDownloadToken=${new Date().getTime()}`;
        if (data.fileVersion) {
            docUrl = docUrl + '&fileVersion=' + data.fileVersion;
        }
        return next({
            type: action.type,
            isOnline: action.isOnline,
            meta: {
                api: {
                    url: docUrl,
                    method: 'GET',
                    data: {},
                    headers: {
						engagementid: data.engagementId
					},
					payload: data,
					responseType: 'blob'
                }
            }
        })
    }

    return next(action);


};

export default ceapDownloadMiddleware;
